import React, { useState, useRef, useEffect } from 'react';
import './FileUpload.scss';
import { MdCloudUpload, MdDelete } from 'react-icons/md';
import { AiFillFileImage } from 'react-icons/ai';
import PropTypes from "prop-types";
import { propTypes } from 'react-bootstrap/esm/Image';


function FileUploader({ initialImage = null, initialFileName = "No selected file", onChange, onClick, noSelectedFile, browseFilesToUpload, imageDisabled = false }) {
  const [image, setImage] = useState(initialImage);
  const [fileName, setFileName] = useState(initialFileName);
  const [browseFilesTo, setBrowseFilesToUpload] = useState(browseFilesToUpload);
  const inputRef = useRef(null);

  useEffect(() => {
    setImage(initialImage);
    setFileName(initialFileName);
    setBrowseFilesToUpload(browseFilesToUpload);
  }, [initialImage, initialFileName, browseFilesToUpload]);

  const handleFileChange = ({ target: { files } }) => {
    if (files[0]) {
      if (onChange) {
        onChange(files[0]);
        setFileName(files[0].name);
        setImage(URL.createObjectURL(files[0]));
      }
    }
  };

  const handleFileClick = () => {

    if (!imageDisabled) {
      if (onClick) {
        onClick();
      }
      setFileName(noSelectedFile);
      setImage(null);
    }
  };


  return (
    <main>
      <form
        role="button"
        tabIndex="0"
        onClick={() => inputRef.current.click()}
        onKeyDown={(e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            inputRef.current.click();
          }
        }}
      >
        <input
          type="file"
          className='input-field'
          hidden
          ref={inputRef}
          onChange={handleFileChange}
          accept='application/pdf, image/jpeg, image/png, image/tiff'
        />

        {image ? (
          <img src={image} width={150} height={150} alt={fileName} />
        ) : (
          <>
            <MdCloudUpload color='#1475cf' size={60} />
            <p>{browseFilesTo}</p>
          </>
        )}
      </form>

      <section className='uploaded-row'>
        <AiFillFileImage color='#1475cf' />
        <span className='upload-content'>
          {fileName} -
          <MdDelete
            onClick={handleFileClick}
          />
        </span>
      </section>
    </main>
  );
}

FileUploader.propTypes = {
  onClick: PropTypes.func,
  onChange: PropTypes.func,
  initialImage: PropTypes.any,
  initialFileName: PropTypes.any,
  noSelectedFile: PropTypes.any,
  browseFilesToUpload: PropTypes.any,
  t: PropTypes.any,
  imageDisabled: PropTypes.any
};

export default FileUploader;
